import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { Router } from '@angular/router';
import { Routes } from 'src/app/core/routes/routes';
import { AuthApi } from '@core/auth/services/auth-api';
import { AuthLogin } from '@core/auth/models/auth.model';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '@core/auth/services/auth-service';
import { Footer } from "@shared/components/footer/footer";

@Component({
  selector: 'app-login',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InputTextModule,
    MessageModule,
    PasswordModule,
    CheckboxModule,
    ButtonModule,
    Footer
],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
  private router = inject(Router);
  private authApi = inject(AuthApi);
  private authService = inject(AuthService);
  
  isFormSubmitted = false;
  isLoading = false;
  formErrorMessage = '';

  form: FormGroup = new FormGroup({
    userName: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
    rememberMe: new FormControl(false)
  })

  ngOnInit() {
    const rememberMe = localStorage.getItem('rememberMe');
    const rememberedUser = localStorage.getItem('rememberedUser');
  
    if (rememberMe === 'true' && rememberedUser) {
      this.form.patchValue({
        userName: rememberedUser,
        rememberMe: true
      });
    }
  }

  onSubmit(): void {
    this.isFormSubmitted = true;
    
    if (this.form.invalid) {
      return;
    }

    this.isLoading = true;
    this.formErrorMessage = '';

    const credentials: AuthLogin = {
      UserName: this.form.get('userName')!.value,
      Password: this.form.get('password')!.value
    };

    const rememberMe = this.form.get('rememberMe')?.value || false;

    this.authService.login(credentials, rememberMe).subscribe({
      next: (_) => {
        this.form.reset();
        this.isFormSubmitted = false;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.formErrorMessage = error.error?.Message || 'Error al iniciar sesión.';
        this.isLoading = false;
      }
    });
  }
  
  isInvalid(controlName: string) {
    const control = this.form.get(controlName);
    return control?.invalid && (control.touched || this.isFormSubmitted);
  }

  redirectToRecoverPassword() {
    this.router.navigate([Routes.recoverPasswordPage])
  }
}
